import React, { useEffect, useState } from "react";
import Footer from "../Sub/Footer";
import webBanner from "../../images/webBanner.jpg";
import CommonHeader from "../Sub/CommonHeader";
import Banner from "../Sub/Banner";
import { Form, Row, Col, Button } from "react-bootstrap";
import BrandsLogo from "../Sub/BrandsLogo";
import { Formik } from "formik";
import * as yup from "yup";
import { getSocialMediaSettings } from "../../reducers/commonReducer";
import { useDispatch, useSelector } from "react-redux";

const schema = yup.object().shape({
  name: yup.string().required(),
  gst: yup.string(),
  email: yup.string().email().required(),
  phone: yup.string().min(10).max(10).required(),
  password: yup.string().required(),
});

const Contact = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSocialMediaSettings());
  }, []);

  const { getSocialMediaSettingsData } = useSelector(
    (state) => state.commonReducer
  );

  return (
    <>
      <CommonHeader />
      {/* <div>
        <Banner bannerImg={webBanner} />
      </div> */}
      <div className="mutual-fund-container">
<h2 className="mutual-fund-heading text-start">
Contact <span>Us</span>
</h2>

<div className="fund-section elss-section">
  <div>
  <div>
                <h3 className="text-metual"><b>Address</b></h3>
               
                <p className="mb-1">{getSocialMediaSettingsData?.address}</p>
                <p className="mb-4">
                  {getSocialMediaSettingsData?.city}, {getSocialMediaSettingsData?.state},{" "}
                  {getSocialMediaSettingsData?.zip}
                </p>
              </div>
              <div>
                <h3 className="text-metual"><b>Mobile No.</b></h3>
                <p>+91 {getSocialMediaSettingsData?.phone}</p>
              </div>
              <div>
                <h3 className="text-metual"><b>Email</b></h3>
                <p> {getSocialMediaSettingsData?.mail}</p>
              </div>
  </div>
  <div className="fund-text">
    {/* <h3>ELSS (tax saving funds)</h3>
    <p>Invest in ELSS mutual funds to save on taxes while growing your wealth over time.</p> */}


<div className="border-y mb-4">
                {/* <h2 className="mb-0 text-metual">
                  Get In Touch
                </h2> */}
                {/* <h3 className="text-metual"><b> Get In Touch</b></h3> */}
              </div>
              <Formik
                validationSchema={schema}
                onSubmit={async (values, { resetForm }) => {
                  //   dispatch(orderCreate(values));
                  resetForm({ values: "" });
                }}
                initialValues={{
                  name: "",
                  email: "",
                  phone: "",
                  // password: "",
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  touched,
                  values,
                  errors,
                }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Col md={6} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            isInvalid={!!errors.name}
                            className={errors.name && touched.name && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    
                      <Col md={6} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Phone</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Phone"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            isInvalid={!!errors.phone}
                            className={errors.phone && touched.phone && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">

                    <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            isInvalid={!!errors.email}
                            className={errors.email && touched.email && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {/* <Col md={6} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Phone</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Phone"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            isInvalid={!!errors.phone}
                            className={errors.phone && touched.phone && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col> */}
                      {/* <Col md={6} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Password"
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            isInvalid={!!errors.password}
                            className={errors.password && touched.password && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.password}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col> */}
                    </Row>
                    {/* <Button variant="success" className="get-in-touch" type="submit">
                      Save
                    </Button> */}
                    <Button className="get-in-touch mbl-hide " type="submit">Save</Button>
                  </Form>
                )}
              </Formik>
  </div>
</div>



</div>
      {/* <div className="container-fluid">
        <div className="page-main p-5 mbl-pedding-10">
          <div className="section__head d-md-flex justify-content-between mb-40"><div className="section__title">
            <h1 className="text-metual">Contact <span>Us</span></h1></div>
          </div>
          <Row className="align-item-center">
            <Col md={6} className="hideMb">
              <div>
                <h3 className="text-metual"><b>Address</b></h3>
               
                <p className="mb-1">{getSocialMediaSettingsData?.address}</p>
                <p className="mb-4">
                  {getSocialMediaSettingsData?.city}, {getSocialMediaSettingsData?.state},{" "}
                  {getSocialMediaSettingsData?.zip}
                </p>
              </div>
              <div>
                <h3 className="text-metual"><b>Mobile No.</b></h3>
                <p>+91 {getSocialMediaSettingsData?.phone}</p>
              </div>
              <div>
                <h3 className="text-metual"><b>Email</b></h3>
                <p> {getSocialMediaSettingsData?.mail}</p>
              </div>
            </Col>
            <Col md={6} className="box-shadows mbl-pedding-10">
              <div className="border-y mb-4">
                <h2 className="mb-0 text-metual">
                  Get In Touch
                </h2>
              </div>
              <Formik
                validationSchema={schema}
                onSubmit={async (values, { resetForm }) => {
                    dispatch(orderCreate(values));
                  resetForm({ values: "" });
                }}
                initialValues={{
                  name: "",
                  email: "",
                  phone: "",
                  password: "",
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  touched,
                  values,
                  errors,
                }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            isInvalid={!!errors.name}
                            className={errors.name && touched.name && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.name}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            isInvalid={!!errors.email}
                            className={errors.email && touched.email && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Phone</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Phone"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            isInvalid={!!errors.phone}
                            className={errors.phone && touched.phone && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={6} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Phone</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Phone"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            isInvalid={!!errors.phone}
                            className={errors.phone && touched.phone && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Password"
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            isInvalid={!!errors.password}
                            className={errors.password && touched.password && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.password}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button variant="success" className="get-in-touch" type="submit">
                      Save
                    </Button>
                    <Button className="get-in-touch mbl-hide " type="submit">Save</Button>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
          <Row className="mt-4">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3484.369330583795!2d75.71985481509444!3d29.15378688221505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391233290784a089%3A0xdcd38b30f119404f!2sSHREE%20HIRA%20COMPUTER!5e0!3m2!1sen!2sin!4v1674287123925!5m2!1sen!2sin" style={{ width: "100%", height: "400", style: "border:0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </Row>
          <BrandsLogo />
        </div>
      </div> */}
      <Footer />
    </>
  );
};

export default Contact;



